module.exports = __webpack_public_path__ + "static/media/Heart.d8047150.png";